module.exports = __webpack_public_path__ + "img/icon_map_108_on_110.604e06b6.png";